module.exports = __webpack_public_path__ + "static/img/banner4.34fce13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner4.png
// module id = oXVe
// module chunks = 0